import React from 'react';

export const AlternativeAdd = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <path
      fillRule="evenodd"
      d="M20 15.765c.37 0 .672.283.703.645l.003.06v2.824h2.823c.39 0 .706.316.706.706 0 .37-.283.672-.645.703l-.06.003h-2.824v2.823c0 .39-.316.706-.706.706-.37 0-.672-.283-.703-.645l-.003-.06v-2.824H16.47c-.39 0-.706-.316-.706-.706 0-.37.283-.672.645-.703l.06-.003h2.824V16.47c0-.39.316-.706.706-.706z"
    />
  </svg>
);
